import * as THREE from "three";
import { PLANET_RADIUS } from "./sphere";

export class CameraRig {
  yaw = 0.55;
  pitch = 0.78;
  distance = 11.5;
  private readonly minDistance = 4.2;
  private readonly maxDistance = 24;
  private readonly minR = PLANET_RADIUS + 0.5;
  private readonly target = new THREE.Vector3();
  private readonly offset = new THREE.Vector3();
  private readonly east = new THREE.Vector3();
  private readonly north = new THREE.Vector3();
  private readonly up = new THREE.Vector3();

  constructor(private readonly camera: THREE.PerspectiveCamera) {}

  orbit(dx: number, dy: number): void {
    this.yaw -= dx * 0.005;
    this.pitch += dy * 0.004;
    this.pitch = THREE.MathUtils.clamp(this.pitch, 0.14, 1.32);
  }

  zoom(deltaY: number): void {
    this.distance = THREE.MathUtils.clamp(this.distance * (1 + deltaY * 0.001), this.minDistance, this.maxDistance);
  }

  follow(playerPos: THREE.Vector3): void {
    this.up.copy(playerPos).normalize();
    this.east.set(0, 1, 0).cross(this.up);
    if (this.east.lengthSq() < 1e-6) {
      this.east.set(1, 0, 0).cross(this.up);
    }
    this.east.normalize();
    this.north.copy(this.up).cross(this.east).normalize();

    const cosP = Math.cos(this.pitch);
    const sinP = Math.sin(this.pitch);
    this.offset
      .copy(this.east)
      .multiplyScalar(Math.sin(this.yaw) * cosP * this.distance)
      .addScaledVector(this.north, Math.cos(this.yaw) * cosP * this.distance)
      .addScaledVector(this.up, sinP * this.distance);

    this.target.copy(playerPos).addScaledVector(this.up, 0.72);
    this.camera.position.copy(this.target).add(this.offset);
    if (this.camera.position.length() < this.minR) {
      this.camera.position.normalize().multiplyScalar(this.minR);
    }
    this.camera.up.copy(this.up);
    this.camera.lookAt(this.target);
  }
}
